import { render, staticRenderFns } from "./shipping-file-management.vue?vue&type=template&id=c17d4cec"
import script from "./shipping-file-management.vue?vue&type=script&lang=js"
export * from "./shipping-file-management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c17d4cec')) {
      api.createRecord('c17d4cec', component.options)
    } else {
      api.reload('c17d4cec', component.options)
    }
    module.hot.accept("./shipping-file-management.vue?vue&type=template&id=c17d4cec", function () {
      api.rerender('c17d4cec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CustomerViews/ShippingManagement/shipping-file-management.vue"
export default component.exports